export default () => ({
    root: {
        marginLeft: '250px'
    }
})